module.exports = __webpack_public_path__ + "static/media/ttf-watershed-partnership.51c5bb25.md";